module.exports = __webpack_public_path__ + "static/media/Blog_solar_And_hybrid_energy.3225cccd.webp";